import { toString, Union } from "../../fable_modules/fable-library-js.4.17.0/Types.js";
import { obj_type, union_type, int32_type } from "../../fable_modules/fable-library-js.4.17.0/Reflection.js";
import { ReportReason, ReportReason__ToInt, ReportReason_AsArray } from "../../Shared/Shared.js";
import { createElement } from "react";
import React from "react";
import { React_functionComponent_Z336EF691, useFeliz_React__React_useState_Static_1505 } from "../../fable_modules/Feliz.2.7.0/React.fs.js";
import { GenericResponse_$reflection, ReportForm_$reflection, ReportForm } from "../../Shared/ApiDataTypes.js";
import { Button_pillButtonSmall, Button_cancelButtonSmall, Dialog_dialogActions, Alert_errorAlert, Dialog_dialogContent, Dialog_dialogTitle, Dialog_Dialog } from "../Components.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.17.0/Seq.js";
import { uncurry2, createObj } from "../../fable_modules/fable-library-js.4.17.0/Util.js";
import { Interop_reactApi } from "../../fable_modules/Feliz.2.7.0/Interop.fs.js";
import { cons, empty as empty_1, singleton as singleton_1, map as map_1, tryHead, tryFind, ofArray } from "../../fable_modules/fable-library-js.4.17.0/List.js";
import { map } from "../../fable_modules/fable-library-js.4.17.0/Array.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { map as map_2, defaultArg, some, unwrap } from "../../fable_modules/fable-library-js.4.17.0/Option.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../../fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../../fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.17.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.17.0/MapUtil.js";
import { toString as toString_1 } from "../../fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { fromString } from "../../fable_modules/Thoth.Json.6.0.0/Decode.fs.js";

export class ReportObject extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AssetReview", "AssetReviewComment", "AssetPost", "AssetPostComment", "User"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "analysekommentar" : ((this$.tag === 2) ? "innlegg" : ((this$.tag === 3) ? "kommentar" : ((this$.tag === 4) ? "bruker" : "analyse")));
    }
}

export function ReportObject_$reflection() {
    return union_type("Aksjeio.Posts.ReportForm.ReportObject", [], ReportObject, () => [[["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]]]);
}

export function ReportObject__ReportReasons(this$) {
    return ReportReason_AsArray();
}

export function ReportObject__ReportUrl(this$) {
    switch (this$.tag) {
        case 1:
            return `/api/review/reply/report/${this$.fields[0]}`;
        case 2:
            return `/api/asset/post/report/${this$.fields[0]}`;
        case 3:
            return `/api/asset/post/reply/report/${this$.fields[0]}`;
        case 4:
            return `/api/user/report/${this$.fields[0]}`;
        default:
            return `/api/review/report/${this$.fields[0]}`;
    }
}

export function Report(reportInputProps) {
    const onClose = reportInputProps.onClose;
    const target = reportInputProps.target;
    const patternInput = useFeliz_React__React_useState_Static_1505({
        Processing: false,
        Reported: false,
    });
    const updateState = patternInput[1];
    const state = patternInput[0];
    let patternInput_2;
    const patternInput_1 = (target.tag === 1) ? ["review-comment", target.fields[0]] : ((target.tag === 2) ? ["asset-post", target.fields[0]] : ((target.tag === 3) ? ["asset-post-comment", target.fields[0]] : ((target.tag === 4) ? ["user", target.fields[0]] : ["review", target.fields[0]])));
    patternInput_2 = useFeliz_React__React_useState_Static_1505(new ReportForm(patternInput_1[0], patternInput_1[1], ReportReason__ToInt(new ReportReason(0, [])), ""));
    const updateReportForm = patternInput_2[1];
    const reportForm = patternInput_2[0];
    return createElement(Dialog_Dialog, {
        onClose: onClose,
        children: ofArray([Dialog_dialogTitle(`Rapporter ${toString(target)}`), Dialog_dialogContent(toList(delay(() => {
            let elems, value_10, onChange_1, options_1;
            return append(state.Reported ? singleton(createElement("div", createObj(ofArray([["style", {
                textAlign: "center",
                width: 100 + "%",
            }], (elems = [createElement("span", {
                children: ["Rapporteringen er mottatt"],
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))) : append(singleton((value_10 = (reportForm.Reason | 0), (onChange_1 = ((e) => {
                updateReportForm(new ReportForm(reportForm.Target, reportForm.TargetId, e, reportForm.Comment));
            }), (options_1 = ofArray(map((rr) => [toString(rr), ReportReason__ToInt(rr)], ReportObject__ReportReasons(target))), React_functionComponent_Z336EF691((props_3) => {
                let elems_5, elems_4, elems_2, elems_1, elems_3;
                const patternInput_3 = useFeliz_React__React_useState_Static_1505(false);
                const setIsOpen = patternInput_3[1];
                const isOpen = patternInput_3[0];
                let selected;
                const _arg_1_2 = tryFind((tupledArg) => (tupledArg[1] === value_10), options_1);
                selected = ((_arg_1_2 == null) ? tryHead(options_1) : _arg_1_2);
                return createElement("div", createObj(ofArray([["className", "dropdown"], (elems_5 = [createElement("div", createObj(singleton_1((elems_4 = [createElement("div", createObj(ofArray([["className", "dropdown-current"], ["onClick", (_arg_2_1) => {
                    setIsOpen(!isOpen);
                }], (elems_2 = [createElement("label", {
                    children: "Begrunnelse",
                }), createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 5 + "px ",
                }], (elems_1 = toList(delay(() => {
                    let matchValue_1;
                    return append((matchValue_1 = selected, (matchValue_1 != null) ? singleton(matchValue_1[0]) : singleton("Ingen valgt")), delay(() => singleton(createElement("i", {
                        className: isOpen ? "fas fa-chevron-up" : "fas fa-chevron-down",
                    }))));
                })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", {
                    style: createObj(toList(delay(() => (!isOpen ? singleton(["display", "none"]) : empty())))),
                    className: "dropdown-content",
                    children: createElement("ul", createObj(singleton_1((elems_3 = map_1((tupledArg_1) => {
                        let s_2;
                        const v = tupledArg_1[1] | 0;
                        return createElement("li", {
                            onClick: (_arg_3_1) => {
                                setIsOpen(false);
                                onChange_1(v);
                            },
                            className: (selected != null) ? ((selected[1] === v) ? ((s_2 = (selected[1] | 0), "dropdown-option dropdown-option-selected")) : "dropdown-option") : "dropdown-option",
                            children: tupledArg_1[0],
                        });
                    }, options_1), ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])))),
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))]))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])));
            })({
                onChange: onChange_1,
                value: value_10,
            }))))), delay(() => singleton(createElement("textarea", {
                rows: 5,
                placeholder: "Kommentar (valgfritt)",
                defaultValue: reportForm.Comment,
                onChange: (ev) => {
                    updateReportForm(new ReportForm(reportForm.Target, reportForm.TargetId, reportForm.Reason, ev.target.value));
                },
                style: {
                    borderRadius: 5,
                    padding: 5,
                },
            })))), delay(() => singleton(Alert_errorAlert(state.ErrorMsg, () => {
                updateState({
                    Processing: state.Processing,
                    Reported: state.Reported,
                });
            }))));
        }))), Dialog_dialogActions(toList(delay(() => append(singleton(Button_cancelButtonSmall("Avbryt", (_arg_5) => {
            onClose();
        }, empty_1())), delay(() => (!state.Reported ? singleton(Button_pillButtonSmall("Rapporter", (_arg_6) => {
            if (!state.Processing) {
                const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let body, decoder, data_1, caseStrategy_3, extra_3;
                    updateState({
                        ErrorMsg: unwrap(state.ErrorMsg),
                        Processing: true,
                        Reported: state.Reported,
                    });
                    const requestPath = ReportObject__ReportUrl(target);
                    return ((body = Auto_generateBoxedEncoder_437914C6(ReportForm_$reflection(), undefined, undefined, undefined)(reportForm), (decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                        let properties_2;
                        try {
                            const properties_3 = Helper_withProperties(singleton_1(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_2((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_3, extra_3)(data_1_1))]), properties_2), data_1), properties_2)));
                            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                                let response_1, decoder_1_1;
                                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                                    let matchValue;
                                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                            }))));
                            return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                        }
                        catch (exn) {
                            return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                        }
                    })())))))).then((_arg_2) => {
                        const res = _arg_2;
                        if (res.tag === 0) {
                            const x_1 = res.fields[0];
                            if (x_1.Result === "success") {
                                updateState({
                                    ErrorMsg: unwrap(state.ErrorMsg),
                                    Processing: false,
                                    Reported: true,
                                });
                                return Promise.resolve();
                            }
                            else {
                                updateState({
                                    ErrorMsg: x_1.Message,
                                    Processing: false,
                                    Reported: state.Reported,
                                });
                                return Promise.resolve();
                            }
                        }
                        else {
                            updateState({
                                ErrorMsg: "Kunne ikke registrere rapportering. Vennligst prøv igjen senere.",
                                Processing: state.Processing,
                                Reported: state.Reported,
                            });
                            return Promise.resolve();
                        }
                    });
                }));
                pr_1.then();
            }
        }, empty_1())) : empty()))))))]),
    });
}

